import type { DraggableHeaderProps } from './index.types';
import { ReactComponent as CrossIcon } from 'Assets/icons/cross.svg';
import dragIcon from 'Assets/images/drag.svg';
import React from 'react';
import { IconButton } from '~/lib/ui/icon-button';


/**
 * DraggableHeader - Header component for draggable popout windows
 *
 * Displays a centered drag handle with an optional close button.
 * The drag handle uses a CSS class that react-rnd recognizes for dragging.
 */
export const DraggableHeader: React.FC<DraggableHeaderProps> = ({
  dragHandleClassName = 'drag-handle',
  showCloseButton = false,
  onClose,
}) => {

  const isCloseButtonEnabled = showCloseButton && onClose;

  return (
    <div
      className={`${dragHandleClassName} relative flex items-center justify-between h-[30px] px-4 bg-accent cursor-grab active:cursor-grabbing`}
    >
      {/* Left spacer for alignment when close button is shown */}
      <div className="w-6" aria-hidden="true" />

      <div
        className="size-[24px] bg-center bg-no-repeat cursor-grab active:cursor-grabbing"
        style={{ backgroundImage: `url(${dragIcon})` }}
        aria-label="Drag handle to move window"
        role="img"
      />

      {isCloseButtonEnabled ? (
        <div className="-mr-[14px]">
          <IconButton
            icon={CrossIcon}
            label=""
            onClick={() => { onClose(); }}
            variant="ghost"
            iconSize={14}
            buttonClassName="size-[30px] rounded-none cursor-pointer focus:outline-none focus-visible:rounded-tr-xl focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring/50"
            containerClassName="gap-0"
            testID="softphone-dialpad-close"
            title="Close dialpad"
          />
        </div>
      ) : (
        <div className="w-6" aria-hidden="true" />
      )}
    </div>
  );
};
